import type { ToPlanQuantityColumns } from "./types";

export const toPlanQuantityColumns: ToPlanQuantityColumns = ({ planColumns }) =>
  planColumns.map((planColumn) => ({
    id: `plan_${planColumn.floorPlanId}`,
    header: planColumn.planName,
    floorPlanIds: [planColumn.floorPlanId],
  }));
